import { SocieteModel } from './../../../shared/models/simple-types/societe.model';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { BcComponentsService, DetailBcLineinfos, DetailBcinfos } from '../bc-components.service';
import { Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SelectSocietyModalComponent } from 'src/app/shared/components/modals/select-society-modal/select-society-modal.component';
import { StateService } from 'src/app/shared/services/state.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { ModalCycleValidationComponent } from '../modals/modal-cycle-validation/modal-cycle-validation.component';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

@Component({
  selector: 'app-create-bc',
  templateUrl: './create-bc.component.html',
  styleUrls: ['./create-bc.component.scss']
})
export class CreateBcComponent implements OnInit , OnDestroy {

  bcForm: UntypedFormGroup;
  currentSociety: SocieteModel;
  bc: BcModel = new BcModel();
  detailBcInfo: DetailBcinfos = new DetailBcinfos();
  observableBc = new BehaviorSubject<BcModel>(new BcModel());
  bcLineHTs = 0;
  bcLineTVAs = 0;
  bcLineTTCs = 0;
  articleLib = '';
  ca1: Ca1Model = null;
  site: SiteModel = null;
  selectedSociete: SocieteModel;
  bcLinesKeys = Object.keys;
  definitionTypeBC = DefinitionTypeBC;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private title: Title,
    private bcComponentsService: BcComponentsService,
    private state: StateService,
    protected toastr: ToastrService,
    private el: ElementRef) {
    this.chooseSociety();
  }

  ngOnInit(): void {

    this.bcComponentsService.loadDetailBc().subscribe((infos: DetailBcinfos) => {
      this.detailBcInfo = infos;
    });

    this.state.society.subscribe(result => {
      this.currentSociety = result;
      this.observableBc.subscribe(obj => {
        this.bc = obj;
        this.bc.societe = this.currentSociety;
        this.bcForm = this.bcComponentsService.getCreateBcFormGroup();
        this.bcForm.patchValue(this.bc);
      });
    });

  }

  close(): void {
    this.router.navigate(['/']);
  }
  ngOnDestroy(): void {
    this.bcComponentsService.purgeDetailBcInfo();
  }

  print(): void {
    window.open('/assets/pdfs/bcpdf.pdf');
  }

  setValuesToBc(): void {
    this.bc = this.bcForm.getRawValue();
    this.bc.bcLines = (this.bcForm.get('bcLines') as UntypedFormArray).getRawValue();
    this.bc.idSociete = this.currentSociety.id;
    this.bc.code = this.bcForm.controls.code.value;
    this.bc.libelle = this.bcForm.controls.libelle.value;
    this.bc.societe = this.currentSociety;
    this.bc.tva = this.bcLineTVAs;
    this.bc.ht = this.bcLineHTs;
    this.bc.ttc = this.bcLineTTCs;
  }


  memorize(): void {
    if (this.bcForm.valid) {
      if (this.bcForm.get('codeSite').value) {
        this.setValuesToBc();
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.bcComponentsService.memorizeBc(this.bc).subscribe((data: any) => {
          this.bc = data;
          dialogRef.close();
          this.bc.type === DefinitionTypeBC.BCStandard ? this.router.navigate(['brouillon-bc/' + this.bc.id]) : this.router.navigate(['brouillon-enveloppe-bc/' + this.bc.id]);
        }, (error) => dialogRef.close());
      } else {
        this.toastr.warning('Le champ site est obligatoire', 'Veuillez selectionnée un site ');
      }
    } else {
      this.displayErrors();
      const formArray: UntypedFormArray = this.bcForm.get('bcLines') as UntypedFormArray;
      for (let i = 0; i < formArray.controls.length; i++) {
        for (const bcLineControl in (formArray.controls[i] as UntypedFormGroup).controls) {
          if ((formArray.controls[i] as UntypedFormGroup).controls[bcLineControl].errors) {
            this.toastr.warning('Veuillez remplir le champ : ' + bcLineControl + ' de la ligne ' + i);
          }
        }
      }
    }
  }

  displayErrors(): void {
    for (const bc in this.bcForm.controls) {
      if (bc) {
        this.bcForm.controls[bc].markAsTouched();
      }
    }
  }

  chooseSociety(): void {
    const dialogConfirmation = this.dialog.open(SelectSocietyModalComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        title: 'Choisir une societé/un type BC',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    dialogConfirmation.afterClosed().subscribe((infos: any) => {
      if (infos) {
        this.bc = new BcModel();
        this.currentSociety = infos.currentSociety;
        this.state.changeSociety(this.currentSociety);
        this.bc.societe = this.currentSociety;
        this.bc.idSociete = this.currentSociety.id;
        this.bc.type = infos.currentType;
        this.bcForm.patchValue(this.bc);
        this.bc && this.bc.type === DefinitionTypeBC.BCStandard ? 
          this.title.setTitle('SACHA - Créer BC Simple') : 
        this.title.setTitle('SACHA - Créer BC Enveloppe');
      } else {
        this.ngOnDestroy();
        this.router.navigate(['/']);
      }
    });
  }

  getBcLines(event: any): void {
    const ob = event as UntypedFormGroup;
    if (ob) {
      this.calculateHorsTaxes(event);
      this.calculateTvas(event);
      this.calculateTtcs(event);
    }
  }

  calculateHorsTaxes(object: any): void {
    if (this.getHtAMount(object) != undefined) {
      this.bcLineHTs = this.getHtAMount(object);
    }
  }

  calculateTvas(object: any): void {
    if (this.getTvaAMount(object) !== undefined) {
      this.bcLineTVAs = this.getTvaAMount(object);

    }
  }

  calculateTtcs(object: any): void {
    if (this.getTtcAMount(object) !== undefined) {
      this.bcLineTTCs = this.getTtcAMount(object);
    }
  }

  getHtAMount(object: any): number {
    // tslint:disable-next-line
    let amountsHt = [];
    let amountHtTotal = 0;
    if (!object) {
      return amountHtTotal;
    }
    for (let obj = 0; obj < object.length; obj++) {
      let amountHtValue = 0;
      if (object[obj].amount !== undefined) {
        amountHtValue = amountHtValue + object[obj].amount;
        amountsHt.push(amountHtValue);
        if (obj === object.length - 1) {
          for (const amount of amountsHt) {
            amountHtTotal += amount;
          }
          return amountHtTotal;
        }
      }
    }
  }

  getTvaAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTva = [];
    let amountTvaTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTvaValue = 0;
      if (object[obj].amount !== undefined) {
        amountTvaValue = amountTvaValue + object[obj].amount;
        amountsTva.push(amountTvaValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTva) {
            amountTvaTotal += amount;
          }
          return amountTvaTotal;
        }
      }
    }
  }

  getTtcAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTtc = [];
    let amountTtcTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTtcValue = 0;
      if (object[obj].amount !== undefined) {
        amountTtcValue = amountTtcValue + object[obj].amount;
        amountsTtc.push(amountTtcValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTtc) {
            amountTtcTotal += amount;
          }
          return amountTtcTotal;
        }
      }
    }
  }

  getDesignationSelected(designationLib: string): void {
    this.articleLib = designationLib;
  }

  getSelectedCa1(object: Ca1Model): void {
    this.ca1 = object;
  }
  getSelectedSite(object: SiteModel): void {
    this.site = object;
  }

  openCycleValidation() {
    const dialog = this.dialog.open(ModalCycleValidationComponent, {
      data: {
        idBc: 0,
        idSociete: this.bc.idSociete,
        codeCa1: this.bcForm.get('codeCa1').value
      }
    });
  }

}
